import React from "react";
import { Grid } from "@mui/material";
import LabeledText from "../../Widgets/LabeledText";
import { CaregiverInvolvementFormValues } from "./interface";

interface ViewFieldsProps {
  formValues: CaregiverInvolvementFormValues;
}

export const ViewFields: React.FC<ViewFieldsProps> = ({ formValues }) => {
  return (
    <Grid container sx={{ rowGap: "24px" }}>
      <LabeledText label="Involvement" value={formValues.involvement} />
      <LabeledText label="Barriers to treatment adherence" value={formValues.barriersToTreatmentAdherence} />
      <LabeledText label="Barriers to participation" value={formValues.barriersToParticipation} />
      <LabeledText label="Summary of caregiver participation" value={formValues.summaryCaregiverParticipation} />
      <LabeledText label="Location of caregiver training sessions" value={formValues.locationTrainingSessions} />
    </Grid>
  );
};

export default ViewFields;
